module.exports = __webpack_public_path__ + "static/media/grostaquin.fdef249a.gif";